import PropTypes from "prop-types";
import React from "react";
/**
 * OptGroup is a React component which returns optgroup and options for native select
 *
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function OptGroup(props) {
  const {
    children,
    label
  } = props;
  const options = React.Children.map(children, child => {
    const {
      value,
      children: grandChildren
    } = child.props;
    return _jsx("option", {
      value: value,
      children: grandChildren
    }, value);
  });
  return _jsx("optgroup", {
    label: label,
    children: options
  }, label);
}
OptGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Accepts only MenuItem as children  */
  children: PropTypes.node,

  /** Label for the optgroup tag */
  label: PropTypes.string
} : {};
OptGroup.defaultProps = {
  children: null,
  label: ""
};